import React, { useEffect, useState } from 'react'
import axios from 'axios'
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	MenuItem,
	Typography,
	IconButton
} from '@material-ui/core'
import iziToast from 'izitoast'

import { Close, Add as PlusIcon } from '@material-ui/icons'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { useStoreon } from 'storeon/react'

const useStyles = makeStyles(theme => ({
	cancelButton: {
		color: theme.palette.mode === 'dark' ? '#fff' : undefined
	},
	dialogTitle: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingRight: '16px'
	}
}))
interface Section {
	_id: string
	name: string
}

interface Props {
	onSubSectionAdded?: (newSubSection: any) => void
	onSuccess?: () => void
}

const Createsubsection: React.FC<Props> = ({ onSubSectionAdded, onSuccess }) => {
	const [isOpen, setIsOpen] = useState(false)
	const [sections, setSections] = useState<Section[]>([])
	const [selectedSectionId, setSelectedSectionId] = useState('')
	const [subSectionName, setSubSectionName] = useState('')
	const [description, setDescription] = useState('')
	const [isSubmitting, setIsSubmitting] = useState(false)

	// const createdBy = '6657227e295423a9922a813e'
	const { token } = useStoreon('token')
	const classes = useStyles()

	const handleClose = () => setIsOpen(false)
	const handleCancel = () => {
		setSelectedSectionId('')
		setDescription('')
		setSubSectionName('')
	}
	useEffect(() => {
		if (isOpen) {
			axios
				.get(`${process.env.REACT_APP_API_URL}/api/v1/custom/getSections`, {
					headers: {
						Authorization: ` ${token}`
					}
				})
				.then(response => {
					setSections(response.data)
				})
				.catch(() => {
					iziToast.error({
						message: 'Failed to fetch sections'
					})
				})
		}
	}, [isOpen])

	const handleCreate = () => {
		if (!selectedSectionId || !subSectionName || !description) {
			iziToast.warning({
				message: 'Please fill all required fields.'
			})
			return
		}

		const payload = {
			name: subSectionName,
			sectionId: selectedSectionId,
			description
			// createdBy
		}

		setIsSubmitting(true)

		axios
			.post(`${process.env.REACT_APP_API_URL}/api/v1/custom/createSubSection`, payload, {
				headers: {
					Authorization: ` ${token}`
				}
			})
			.then(response => {
				iziToast.success({
					message: 'Subsection created successfully!'
				})

				onSubSectionAdded?.(response.data)
				onSuccess?.()

				setIsOpen(false)
				setSelectedSectionId('')
				setSubSectionName('')
				setDescription('')
			})
			.catch(() => {
				iziToast.error({
					message: 'Failed to create subsection.'
				})
			})
			.finally(() => {
				setIsSubmitting(false)
			})
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				textTransform: 'none'
			}}
		>
			<Button
				variant="contained"
				style={{
					backgroundColor: '#6c5ce7',
					color: 'white',
					textTransform: 'none'
				}}
				onClick={() => setIsOpen(true)}
			>
				<PlusIcon sx={{ mr: 0.5 }} />
				Add SubSection
			</Button>

			<Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="sm" fullWidth>
				<DialogTitle
					// className={classes.dialogTitle}
					disableTypography
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: 'rgb(125, 110, 241)',
						height: '50px',
						color: 'white',
						padding: '0 16px'
					}}
				>
					<h2 style={{ margin: 0, fontSize: '1.25rem' }}>Add New SubSection</h2>
					{/* <IconButton onClick={handleClose} style={{ marginRight: '-18px' }}> */}
					<Close style={{ color: 'white', cursor: 'pointer' }} onClick={handleClose} />
					{/* </IconButton> */}
				</DialogTitle>
				<DialogContent>
					<Typography variant="body2" color="textPrimary" fontWeight="bold" gutterBottom>
						Section Name
					</Typography>
					<TextField
						autoFocus
						margin="dense"
						select
						fullWidth
						value={selectedSectionId}
						onChange={e => setSelectedSectionId(e.target.value)}
						SelectProps={{
							MenuProps: {
								getContentAnchorEl: null,
								anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
								transformOrigin: { vertical: 'top', horizontal: 'left' },
								PaperProps: {
									style: { maxHeight: 200, overflowY: 'auto' }
								}
							},
							displayEmpty: true
						}}
					>
						<MenuItem value="" disabled>
							Select Section
						</MenuItem>
						{sections.map(section => (
							<MenuItem key={section._id} value={section._id}>
								{section.name}
							</MenuItem>
						))}
					</TextField>

					<Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold' }}>
						SubSection Name
					</Typography>
					<TextField
						autoFocus
						margin="dense"
						type="text"
						placeholder="Enter subsection"
						fullWidth
						value={subSectionName}
						onChange={e => setSubSectionName(e.target.value)}
					/>

					<Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold' }}>
						Description
					</Typography>
					<TextField
						autoFocus
						margin="dense"
						type="text"
						placeholder="Enter description"
						multiline
						rows={3}
						value={description}
						onChange={e => setDescription(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancel} variant="outlined">
						Cancel
					</Button>

					<Button variant="contained" onClick={handleCreate} disabled={isSubmitting}>
						{isSubmitting ? 'Creating...' : 'Create'}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default Createsubsection
